// assuming that 1968-01-26 is the format of the date string
export function DateSmallDecorator(date) {
    let y = date.substring(2, 4)
    let m = date.substring(5, 7)
    let d = date.substring(8, 10)

    return '' + d + '.' + m + '.' + y
}

// transform date object to dd.mm.yyyy
export function DateObjectToExportDateDecorator(date) {
    let y = date.getUTCFullYear()
    let m = date.getMonth() + 1
    let d = date.getDate()

    d = d.length < 2 ? '0' + d : d
    m = m.length < 2 ? '0' + m : m

    return '' + d + '.' + m + '.' + y
}

export function truncate(text, maxLength, useWordBoundary = true, prepend = ' ...') {
  // return if string is "to" short
  if (maxLength >= text.length) {
    return text
  }

  let subString = text.substr(0, maxLength - 1)

  if (useWordBoundary) {
    subString = subString.substr(0, subString.lastIndexOf(' '))
  }

  return subString + prepend
}

function isValidDate(d) {
    return d instanceof Date && !isNaN(d)
}

// 31.12.1968
export function ParseFormInputDate(date) {
    let y = date.substring(6, 10)
    let m = date.substring(3, 5)
    let d = date.substring(0, 2)

    let r = new Date('' + y + '-' + m + '-' + d)
    return isValidDate(r) ? r : false
}

export function ParseDate(date) {
    let y = date.substring(0, 4)
    let m = date.substring(5, 7)
    let d = date.substring(8, 10)

    let r = new Date('' + y + '-' + m + '-' + d)
    return isValidDate(r) ? r : false
}



// WEBPACK FOOTER //
// ./src/helper/index.js